import { ColumnsType } from 'antd/lib/table'
import {
  TColumnsProps,
  TBankAccount,
  TBankAccountFilters,
  TBankAccountFiltersFunc
} from '../types'
import { defaultDateFormat } from 'helper/dates'
import { BANK_ACCOUNT_STATUS_OPTIONS } from './constants'
import { Dropdown } from 'components/Dropdown'
import { ReactComponent as Filter16 } from 'assets/svg/Filter16.svg'
import { ReactComponent as FilterApplied16 } from 'assets/svg/FilterApplied16.svg'
import { Link } from 'components/Link'
import { formatBankAccounName } from '../helpers'
import { BankAccountDetailsStatus } from '../BankAccountDetails/BankAccountDetailsStatus'
import { BankAccountsTableMenu } from './BankAccountsTableMenu'
import {
  ACCOUNT_PURPOSE_OPTIONS,
  ACCOUNT_PURPOSE_OPTIONS_LABELS
} from '../BankAccountDetails/constants'
import { Chips } from 'components/Chips/Chips'

export const columns: (props: TColumnsProps) => ColumnsType<TBankAccount> = ({
  filters,
  applyFilters,
  canSeeBankAccountDetails,
  onSendDeposit,
  onDeleteBankAccount,
  onVerifyDeposit,
  onSetAsDefaultReceivableAccount,
  redirectRoute
}: TColumnsProps): ColumnsType<TBankAccount> => {
  return [
    {
      dataIndex: 'account_number',
      key: 'account_number',
      width: 228,
      title: 'Account',
      render: (_, bankAccount) => {
        const bankAccountName = formatBankAccounName(bankAccount)

        const { uuid, account_number, account_type } = bankAccount
        return account_number && account_type ? (
          canSeeBankAccountDetails ? (
            <Link to={`${redirectRoute}/${uuid}`}>{bankAccountName}</Link>
          ) : (
            <span>{bankAccountName}</span>
          )
        ) : (
          '-'
        )
      }
    },
    {
      dataIndex: 'nickname',
      key: 'nickname',
      width: 160,
      title: 'Account nickname',
      render: (_, { nickname }) =>
        nickname && nickname?.length ? nickname : '-'
    },
    {
      dataIndex: 'purpose',
      key: 'purpose',
      width: 160,
      title: 'Account purpose',
      render: (_, { purpose, is_default }) =>
        ACCOUNT_PURPOSE_OPTIONS_LABELS[purpose] ? (
          <div className="column gap-4">
            <div>{ACCOUNT_PURPOSE_OPTIONS_LABELS[purpose]}</div>
            {is_default && purpose === ACCOUNT_PURPOSE_OPTIONS.RECEIVABLE && (
              <Chips grey className="fit-content">
                Default
              </Chips>
            )}
          </div>
        ) : (
          '-'
        )
    },
    {
      dataIndex: 'bank_name',
      key: 'bank_name',
      width: 160,
      title: 'Bank name'
    },
    {
      dataIndex: 'status',
      key: 'status',
      width: 160,
      title: 'Status',
      filterDropdown: (props) => (
        <Dropdown.Filter<TBankAccountFilters, TBankAccountFiltersFunc, unknown>
          applyFilters={applyFilters}
          appliedFilters={filters}
          items={BANK_ACCOUNT_STATUS_OPTIONS}
          field="statuses"
          {...props}
        />
      ),
      render: (_, { status }) => <BankAccountDetailsStatus status={status} />,
      filterIcon: !!filters?.statuses?.length ? (
        <FilterApplied16 />
      ) : (
        <Filter16 />
      ),
      filterSearch: true,
      sorter: false,
      showSorterTooltip: false
    },
    {
      dataIndex: 'created_on',
      key: 'created_on',
      width: 160,
      title: 'Linked at',
      render: (_, { created_on }) =>
        created_on ? defaultDateFormat(created_on) : '-'
    },
    {
      dataIndex: 'action',
      key: 'action',
      title: '',
      width: 48,
      fixed: 'right',
      render: (_, row) => (
        <BankAccountsTableMenu
          row={row}
          onSendDeposit={onSendDeposit}
          onDeleteBankAccount={onDeleteBankAccount}
          onVerifyDeposit={onVerifyDeposit}
          onSetAsDefaultReceivableAccount={onSetAsDefaultReceivableAccount}
        />
      ),
      showSorterTooltip: false
    }
  ]
}
